import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-red pt-0"
}
const _hoisted_2 = {
  key: 0,
  class: "text-red"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_warning = _resolveComponent("v-btn-warning")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fill: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      (!_ctx.documentAccountingPeriod)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Attention : afin d'accèder aux modules de révision comptable, il est indispensable de créer l'exercice comptable. "))
        : (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            class: "default_card_wm mx-auto pt-2 px-4",
            style: {"background":"#fff !important","border":"solid rgba(0, 0, 0, 0.12) 1px","box-shadow":"none"}
          }, {
            default: _withCtx(() => [
              (_ctx.showAdjustments)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "10",
                        class: "d-flex align-center pr-2"
                      }, {
                        default: _withCtx(() => [
                          _cache[0] || (_cache[0] = _createElementVNode("span", null, " Cut-off ", -1)),
                          (
                            _ctx.documentAdjustmentAcrStatus &&
                            _ctx.documentAdjustmentAcrStatus === 'TO_UPDATE'
                        )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, " ㅤdocument modifié : les régularisations sont à refaire "))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_col, {
                        cols: "1",
                        class: "d-flex align-center justify-end"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.disabledAuditReportLines)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "bottom"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                    _createVNode(_component_v_btn_icon, _mergeProps({
                                      icon: " $oss-edit ",
                                      disabled: _ctx.disabledAuditReportLines
                                    }, props, { size: "x-small" }), null, 16, ["disabled"])
                                  ], 16)
                                ]),
                                default: _withCtx(() => [
                                  (
                                    _ctx.tooltipDocumentAdjustmentBtn &&
                                    _ctx.tooltipDocumentAdjustmentBtn.length
                                )
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.tooltipDocumentAdjustmentBtn), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_ctx.documentAdjustmentAcrStatus)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_ctx.documentAdjustmentAcrStatus === 'TO_UPDATE')
                                        ? (_openBlock(), _createBlock(_component_v_btn_warning, {
                                            key: 0,
                                            color: "error",
                                            onClick: _ctx.goToWindowStep10,
                                            size: "x-small"
                                          }, null, 8, ["onClick"]))
                                        : (_ctx.documentAdjustmentAcrStatus === 'UNKNOWN')
                                          ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                              key: 1,
                                              icon: " $oss-circle-check ",
                                              color: "primary",
                                              onClick: _ctx.goToWindowStep10,
                                              size: "x-small"
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                    ], 64))
                                  : (_openBlock(), _createBlock(_component_v_btn_icon, {
                                      key: 1,
                                      disabled: !_ctx.document.status || _ctx.document.status !== 'VALIDATED',
                                      icon: " $oss-edit ",
                                      color: "primary",
                                      size: "x-small",
                                      onClick: _ctx.goToWindowStep10
                                    }, null, 8, ["disabled", "onClick"]))
                              ], 64))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (
                    _ctx.showFixedAssets &&
                    _ctx.fixedAssetsALs &&
                    _ctx.fixedAssetsALs.length &&
                    _ctx.isAllowedToFixedAsset
                )
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.fixedAssetsALs, (fixedAssetsAL) => {
                    return (_openBlock(), _createBlock(_component_v_row, {
                      "no-gutters": "",
                      key: fixedAssetsAL.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "auto",
                          class: "pr-2 d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, " Générer amos - " + _toDisplayString(fixedAssetsAL.accountableAccount.name) + " - " + _toDisplayString(_ctx.newCommonFormatCurrency(fixedAssetsAL.amountSigned)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_spacer),
                        (_ctx.isAllowedToFixedAsset)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "auto",
                              class: "d-flex justify-end"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.disabledAuditReportLines)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      location: "bottom"
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createElementVNode("div", _mergeProps({ ref_for: true }, props), [
                                          _createVNode(_component_v_btn_icon, _mergeProps({
                                            icon: " $oss-edit ",
                                            disabled: _ctx.disabledAuditReportLines,
                                            ref_for: true
                                          }, props, { size: "x-small" }), null, 16, ["disabled"])
                                        ], 16)
                                      ]),
                                      default: _withCtx(() => [
                                        (
                                        _ctx.tooltipDocumentAdjustmentBtn &&
                                        _ctx.tooltipDocumentAdjustmentBtn.length
                                    )
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.tooltipDocumentAdjustmentBtn), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (
                                    _ctx.document.status &&
                                    _ctx.document.status === 'VALIDATED' &&
                                    _ctx.documentDepreciationsAcrStatus &&
                                    _ctx.documentDepreciationsAcrStatus === 'UNKNOWN'
                                )
                                        ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                            key: 0,
                                            icon: " $oss-circle-check ",
                                            color: "primary",
                                            onClick: ($event: any) => (_ctx.openFixedAssets(fixedAssetsAL.id)),
                                            size: "x-small"
                                          }, null, 8, ["onClick"]))
                                        : (_openBlock(), _createBlock(_component_v_btn_icon, {
                                            key: 1,
                                            icon: " $oss-edit ",
                                            color: "primary",
                                            onClick: ($event: any) => (_ctx.openFixedAssets(fixedAssetsAL.id)),
                                            size: "x-small"
                                          }, null, 8, ["onClick"]))
                                    ], 64))
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}